import { useContext, useEffect, useState } from 'react';
import { NotificationContext } from './notification-provider';

// Consumes the one-shot notification handed over by the page that navigated
// here. The notification is cleared from the app level context as soon as it is
// picked up, so it renders once and does not leak onto the next page.
const usePageNotification = () => {
  const [notification, setNotification] = useContext(NotificationContext);
  const [pageNotification, setPageNotification] = useState(null);

  useEffect(() => {
    if (notification) {
      setPageNotification(notification);
      setNotification(null);
    }
  }, [notification, setNotification]);

  return pageNotification;
};

export default usePageNotification;
